const {ContactInformationModel} = require('./ContactInformationModel')
const {AddressModel} = require('./AddressModel')

/**
 * CustomerCompanyModel
 */
class CustomerCompanyModel {
    /**
     * Constuctor
     * @param {text} company
     * @param {ContactInformationModel} billingInfo
     * @param {text} website
     * @param {AddressModel} address
     * @param {ContactInformationModel} contactPerson
     * @param {text} paymentTermsText
     * @param {number} paymentDays
     */
    constructor(
        company='',
        billingInfo=new ContactInformationModel(),
        website='',
        address=new AddressModel(),
        contactPerson=new ContactInformationModel(),
        paymentTermsText='Net 30',
        paymentDays=30,
    ) {
        this.company = company
        this.billing_info = billingInfo
        this.website = website
        this.address = address
        this.contact_person = contactPerson
        this.payment_terms_text = paymentTermsText
        this.payment_days = paymentDays
    }

    /**
     * @param {json} json
     * @return {CustomerCompanyModel}
     */
    static from(json) {
        const customer = Object.assign(new CustomerCompanyModel(), json)

        customer.billing_info =
            ContactInformationModel.from(customer.billing_info)
        customer.addresss =
            AddressModel.from(customer.address)
        customer.contact_person =
            AddressModel.from(customer.contact_person)

        return customer
    }
}

module.exports = {
    CustomerCompanyModel,
}

